import React, { useEffect, useState } from "react";
import { Plus, Save, Trash2 } from "lucide-react";
import { API_BASE_URL, authHeaders } from "../../api";

const createEngagement = (id) => ({
    id,
    title: "",
    description: "",
    image: ""
});

function AdminEngagement() {
    const [items, setItems] = useState([]);
    const [status, setStatus] = useState("");

    useEffect(() => {
        async function loadEngagement() {
            try {
                const response = await fetch(`${API_BASE_URL}/api/engagement`, {
                    headers: authHeaders()
                });
                const data = await response.json();
                setItems(data);
            } catch (error) {
                console.error("Fehler beim Abrufen der Engagement-Daten:", error);
            }
        }

        loadEngagement();
    }, []);

    const updateItem = (index, field, value) => {
        setItems((current) => current.map((item, itemIndex) => (
            itemIndex === index ? { ...item, [field]: value } : item
        )));
    };

    const addItem = () => {
        const nextId = items.reduce((max, item) => Math.max(max, Number(item.id) || 0), 0) + 1;
        setItems((current) => [...current, createEngagement(nextId)]);
    };

    const removeItem = (index) => {
        setItems((current) => current.filter((_, itemIndex) => itemIndex !== index));
    };

    const saveItems = async () => {
        setStatus("Speichert...");

        try {
            const response = await fetch(`${API_BASE_URL}/api/engagement`, {
                method: "PUT",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(items)
            });

            if (!response.ok) {
                throw new Error("Speichern fehlgeschlagen");
            }

            const data = await response.json();
            setItems(data.engagement);
            setStatus("Gespeichert");
        } catch (error) {
            console.error(error);
            setStatus("Fehler beim Speichern");
        }
    };

    return (
        <div className="action-card">
            <h3>Engagement</h3>
            <div className="action-card-body">
                {items.map((item, index) => (
                    <div className="cv-edit-item" key={`${item.id}-${index}`}>
                        <div className="form-grid">
                            <label className="field-label" htmlFor={`engagement-title-${index}`}>Titel</label>
                            <input
                                id={`engagement-title-${index}`}
                                className="text-input"
                                value={item.title}
                                onChange={(event) => updateItem(index, "title", event.target.value)}
                            />

                            <label className="field-label" htmlFor={`engagement-image-${index}`}>Bilddatei</label>
                            <input
                                id={`engagement-image-${index}`}
                                className="text-input"
                                value={item.image}
                                onChange={(event) => updateItem(index, "image", event.target.value)}
                            />
                        </div>

                        <label className="field-label" htmlFor={`engagement-description-${index}`}>Beschreibung</label>
                        <textarea
                            id={`engagement-description-${index}`}
                            className="textarea"
                            value={item.description}
                            onChange={(event) => updateItem(index, "description", event.target.value)}
                        />

                        <button
                            type="button"
                            className="btn btn-outline-danger icon-label-button"
                            onClick={() => removeItem(index)}
                        >
                            <Trash2 size={18} />
                            Entfernen
                        </button>
                    </div>
                ))}

                <div className="admin-actions">
                    <button type="button" className="btn btn-secondary icon-label-button" onClick={addItem}>
                        <Plus size={18} />
                        Eintrag hinzufügen
                    </button>
                    <button type="button" className="btn btn-success icon-label-button" onClick={saveItems}>
                        <Save size={18} />
                        Speichern
                    </button>
                    {status && <span className="save-status">{status}</span>}
                </div>
            </div>
        </div>
    );
}

export default AdminEngagement;
